<template>
  <div class="input_field" :class="{ disabled }">
    <div class="label">
      <slot name="label">
        {{ label }}
      </slot>
    </div>
    <div class="input_row">
      <i
        class="icon"
        :class="[fontFamily, iconClass]"
        v-if="iconClass"
        :style="{ fontSize: `${iconSize}px` }"
      />
      <SjInput
        class="input"
        ref="input"
        :value="value"
        :padding="1"
        @input="$emit('input', $event)"
        :disabled="disabled"
        @blur="$emit('blur')"
        @focus="$emit('focus')"
        v-bind="$attrs"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "SjInputField",
  props: {
    label: String,
    fontFamily: {
      type: String,
      default: "icon_com"
    },
    iconClass: String,
    iconSize: {
      default: 16,
      type: Number
    },
    value: [String, Number],
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleInput(ev) {
      this.$emit("input", ev.target.value);
    },
    focus() {
      this.$refs.input.focus();
    }
  }
};
</script>

<style scoped lang="less">
@disable-color: @color-light;

.input_field {
  border-bottom: 1px solid @color-normal;
  padding-bottom: 2px;
  &.disabled {
    border-color: @disable-color;
    .input_row {
      .icon {
        color: @disable-color;
      }
    }
  }
  .label {
    margin-bottom: 10px;
    .text("h3", "dark");
  }
  .input_row {
    display: flex;
    align-items: center;
    .icon {
      color: @color-dark;
      margin-right: 10px;
    }
    .input {
      width: 100%;
      height: 22px;
    }
  }
}
</style>
